'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _camelcase = require('camelcase');

var _camelcase2 = _interopRequireDefault(_camelcase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Actions = function () {
  _createClass(Actions, null, [{
    key: 'makeActionCreator',


    /**
     * @see http://redux.js.org/docs/recipes/ReducingBoilerplate.html
     */
    value: function makeActionCreator(type) {
      for (var _len = arguments.length, argNames = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        argNames[_key - 1] = arguments[_key];
      }

      return function actionCreator() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var action = { type: type };
        argNames.forEach(function (arg, index) {
          return action[argNames[index]] = args[index];
        });
        return action;
      };
    }
  }]);

  function Actions(config) {
    var _this = this;

    _classCallCheck(this, Actions);

    this.types = {};
    this.creators = {};

    Object.keys(config).forEach(function (type) {

      // add type to instance and instance.types for convenience
      _this[type] = _this.types[type] = type;

      var camelKey = (0, _camelcase2.default)(type);
      var value = config[type];

      // eslint-disable-next-line init-declarations
      var creator = void 0;

      if (Array.isArray(value)) {
        creator = Actions.makeActionCreator.apply(Actions, [type].concat(_toConsumableArray(value)));
      } else if (typeof value === 'string') {
        creator = Actions.makeActionCreator(type, value);
      } else if (typeof value === 'function') {
        creator = value;
      } else if (!value) {
        creator = Actions.makeActionCreator(type);
      }

      // add creator to instance and instance.creators for convenience
      _this[camelKey] = _this.creators[camelKey] = creator.bind(_this);
    });
  }

  return Actions;
}();

exports.default = Actions;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions-class/dist/Actions.js
// module id = 2872
// module chunks = 14